<template id="modal-template">
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
            <div class="container">
                <div class="modal-header">
                    <slot name="header">
                      <span class='t1'><img src="https://app.brighton.com/personalize/static/images/Check.png"/></span>
                      <span class='t2'>Would you like to add amulets to your locket?<br/></span> 
                      <!-- <span class="printlink"><a :href="printoutPdfFileName" target="_Blank">Print</a></span>
                      <span class="printlink"><a :href="downloadFileName" download>Download</a></span> -->
                      <!-- <div v-if="storeType==1" class="consumerOptions">
                        <span  class="printlink" ><a :href="addToCartLink"  target="_Blank">Add To Cart</a></span>
                        or 
                        <br><br>
                        <span><input type="text" v-model="emailAddress" placeholder="YOUR EMAIL ADDRESS"> <button @click="sendEmail">EMAIL</button></span>
                        <span class="emailResult" v-if="emailResult!=''" >{{emailResult}}</span>
                      </div> -->
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body">
                        <div class="body">
                            <div class="amulets" v-if="amulets != null">
                                <div v-for="(amulet, index) in amulets" class="amulet" :class="{selected:amulet.selected}">
                                    <img @click="selectAmulet(index)" :src="'https://media.brighton.com/images/products_thumb/qi'+amulet.STYLE_NUM.toLowerCase()+'_sm.jpg'" alt="">
                                    <span class="price">${{amulet.RETAIL_PRICE}}</span>
                                </div>
                            </div>
                            <button class="modal-default-button" @click="$emit('goCheckOut', amulets)">
                                ADD AMULETS TO CART ({{totalSelected}})
                            </button>&nbsp;
                            <button class="modal-default-button" @click="$emit('goCheckOut', null)">
                                NO THANKS, JUST TAKE ME<br/> TO CHECKOUT
                            </button>
                        </div>
                    </slot>
                </div>
                <div class="modal-footer">
                    <slot name="footer">
                    <!-- <span class="closelink" @click="$emit('close')">Add To Cart ()</span>
                    <span class="closelink" @click="$emit('close')">NO, CLOSE THIS WINDOW</span> -->
                    </slot>
                </div>
        </div>
      </div>
    </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'popupAmulets',
  props: {
    // printoutPdfFileName: null,
    // confirmationNum: null,
    // downloadFileName: null,
    // addToCartLink: String,
    // storeType: Number
    selectedAmulets: Array
},
  data() {
    return {
    //   emailResult:'',
    //   emailAddress: ''
        amulets: null,
        totalSelected: 0
    }
  },
 computed: {
    // keepPrintoutUntilDate () {
    //   var date = new Date();
    //   date.setDate(date.getDate() + 30);
    //   return date.getMonth()+ 1+'/'+date.getDate()+ '/'+date.getFullYear()
    // }
    // selectedAmulets(){
    //     let count = 0;
    //     if(this.amulets != null) {
    //         this.amulets.forEach(amulet =>{
    //             console.log('counting ')
    //             amulet.selected ? count ++: null
    //         })
    //     }
    //     return count
    // }
 },
  methods:{
    selectAmulet(index) {
        this.amulets[index].selected = !this.amulets[index].selected
        this.$forceUpdate()
        if(this.amulets[index].selected)
            this.totalSelected ++
        else 
            this.totalSelected --
        // let count = 0;
        // if(this.amulets != null) {
        //     this.amulets.forEach(amulet =>{
        //         console.log('counting ')
        //         amulet.selected ? count ++: null
        //     })
        // }
    },
    getAllAmulets(){
      this.emailResult=''
      var that = this
      var apiURL = 'https://app.brighton.com/lockets/api/getAllAmulets';
      this.$http.post(
        apiURL,
        {}
        ,
        {emulateJSON: true}
        ).then(response => {
            this.amulets = response.data.data
            this.amulets.map(amulet=> {
                if(this.selectedAmulets != null && this.selectedAmulets.find(sAmulet => {
                    return amulet.UPC == sAmulet.UPC
                })) {
                    this.totalSelected ++
                    amulet.selected = true
                }
                else {
                    amulet.selected = false
                }
            })
        })
    //   var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   if(this.emailAddress.trim() == ''){
    //     this.emailResult = "Email address is required"
    //   } else if(!re.test(this.emailAddress)) {
    //     this.emailResult = "Invalid email address"
    //   } else {
    //     this.$http.post(
    //       apiURL,
    //       {
    //         'emailAddress':this.emailAddress,
    //         'confirmationNum':this.confirmationNum.replace('LOCKETS-', '')
    //       }
    //       ,
    //       {emulateJSON: true}
    //     ).then(response => {
    //       this.emailResult = "Email sent!"
    //       setTimeout(function(){
    //         that.emailResult = ''
    //       }, 3000)
    //     })
    //   }
    }
  },
  mounted () {
      console.log('getting amulets')
      this.getAllAmulets();
  }
}
</script>
<style scoped>
.modal-container {
  font-family: 'Lato', 'Avenir', Helvetica, Arial, sans-serif;
  background-color:#ebebeb;
  /* width: 80%; */
  max-width:960px;
  margin: 0px auto;
  color:#666;
  padding: 20px;
  box-sizing:border-box;
  /*background-color: #fff;*/
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  /* height:80%; */
  /* margin-top:0; */
  height:100%;
  /* height:600px; */
  /* overflow-y:scroll; */
  width:auto;
}
.modal-container span.t1{
    font-size:40px;
    display:block;
}
.modal-container span.t2{
  text-align: center;
  display: block;
  margin: 0px auto;
  font-size: 1.1em;
  font-weight: 600;
  letter-spacing: .08em;
}
.modal-container span.t2 .small{
  font-size:12px;
  line-height:1.5;
  text-transform:initial;
  display:block;

}
.modal-container .container {
    border:1px solid #ccc;
    padding:40px;
    box-sizing:border-box;
    max-width: 960px;
    background-color: #fff;
    height:100%;
    overflow-y:scroll;
}
/*.modal-header{
    border-bottom:1px solid #000;
}*/
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  position: relative;


  position:absolute;
  top:3%;
  left:10%;
  right:10%;
  bottom:10%;
}


.modal-header{
  display:block;
  height:auto;
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 30px 0 0 0;
  font-size: 1.5em;
  height:80%;
  display:block;
  position:relative;
}
.closelink{
  color: #5788a2;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  letter-spacing: 0.1em;
}
.modal-default-button {
  /*float: right;*/
    cursor: pointer;
    display:inline-block;
    padding:0px 30px;
    color:#fff;
    background-color:#5788a2;
    border: none;
    line-height:1.4;
    margin:20px auto;
    font-weight: normal;
    font-size:12px;
    min-height: 53px;
    width:47%;
    vertical-align: middle;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container{
    max-height:100%;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.body{
    display:block;
    height:100%;
    width:80%;
    margin:0 auto;
}
.body .amulets{
    display:block;
    /* height:315px; */
    height:66%;
    margin:0 auto;
    overflow-y:scroll;
    border-top:2px solid #ccc;
    padding:15px 0 0 0;
    box-sizing: border-box;
    text-align: left;
}
.body .amulets .amulet{
    display: inline-block;
    vertical-align: top;
    width: 18%;
    text-align: center;
    margin-bottom: 10px;
    margin: 0 3px 10px 3px;
}
.body .amulets .amulet img{
    display:block;
    max-width:100%;
    box-sizing: border-box;
    border:2px solid white;
    width:auto;
    cursor:pointer;
    transition: border 0.7s;
}
.body .amulets .amulet img:hover,
.body .amulets .amulet.selected img{
    border:2px solid black;
}
.body .amulets .amulet .price{
    font-size:14px;
    color:#5788a2;
    display:block;
}
.t2{
  display:block;
  text-transform:uppercase;
}
.printlink a{
  color:#fff;
  background-color: #5788a2;
  padding:10px 20px;
  text-decoration:none;
  display:block;
  margin: 0 auto;
  width:240px;
  box-sizing:border-box;
}
.consumerOptions{
  display:block;
}
.consumerOptions span{
  display:block;
  width:100%;
}
.consumerOptions input[type=text]{
  border:1px solid #ccc;
  line-height:1.4;
  padding:11px;
  width: 40%;
  vertical-align: middle;
}
.consumerOptions button{
  /* width:240px; */
  padding: 10px 20px;
    font-size: 20px;
    vertical-align: middle;
    margin:0;
    font-weight:normal;
}
.consumerOptions .emailResult{
  display:block;
  padding:3px 5px;
  text-align:center;
  color:red;
  font-weight: bold;
  text-transform: uppercase;
}
@media(max-width:768px){
    .body{
        width:100%;
    }
    .body .amulets .amulet{
        width:23%;
    }
}
@media(max-width:498px){
  .modal-wrapper{
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    width:100%;
  }
  .modal-container{
    width:100%;
  }
  .home .main .right .container{
    padding:10px 3px;
  }
  .modal-container span.t2,
  .printlink,
  .modal-body,
  .modal-default-button{
    font-size:3vw;
    width:100%;
    margin:0;
  }
  .body .amulets{
      margin-bottom:10px;
  }
}
@media(max-width:415px){
    .body .amulets .amulet{
        width:45%;
    }
}
</style>
